// ── Patrimia — Traductions NL (placeholder) ──

import type { Translations } from './fr.js'

export const nl: Translations = {
  common: {
    appName: 'Patrimia',
    loading: 'Laden...',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    archive: 'Archiveren',
    search: 'Zoeken',
    filter: 'Filteren',
    create: 'Aanmaken',
    edit: 'Bewerken',
    close: 'Sluiten',
    all: 'Alle',
    confirm: 'Bevestigen',
    back: 'Terug',
    next: 'Volgende',
    yes: 'Ja',
    no: 'Nee',
    noResults: 'Geen resultaten',
    version: 'v0.1.0',
    copyright: 'Patrimia — IT-Transform',
    login: 'Inloggen',
    logout: 'Uitloggen',
    selectAll: 'Alles selecteren',
    clearAll: 'Alles wissen',
    selected: '{{n}} geselecteerd',
    bulkArchive: 'Selectie archiveren',
    archived: 'Gearchiveerd',
  },
  nav: {
    dashboard: 'Dashboard',
    contacts: 'Contacten',
    mandats: 'Mandaten',
    pipeline: 'Pipeline',
    mailbox: 'Berichten',
    documents: 'Documenten',
    settings: 'Instellingen',
    admin: 'Beheer',
    aria: 'Aria AI',
    // Budget nav
    budgetSynthese: 'Overzicht',
    budgetPerso: 'Persoonlijk',
    budgetPro: 'Professioneel',
    budgetPatrimoine: 'Vermogen',
    budgetTransactions: 'Transacties',
    budgetReconciliation: 'Afstemming',
    // Proprio nav
    proprioBiens: 'Eigendommen',
    proprioBaux: 'Huurcontracten',
    proprioCharges: 'Huurlasten',
    // Syndic nav
    syndicCoproprietes: 'Mede-eigendommen',
    syndicAssemblees: 'Vergaderingen',
    // Notaire nav
    notaireEstimations: 'Schattingen',
    notaireChecklists: 'Checklists',
    budgetCharges: 'Huurlasten Budget',
    budgetFinance: 'Budget',
    invest: 'Beleggingen',
    proprio: 'Eigendom',
    // Outils nav
    agenda: 'Agenda',
    tasks: 'Taken',
    glossaire: 'Woordenlijst',
    templates: 'Templates',
    integrations: 'Integraties',
    breadcrumb: {
      proprio: 'Eigendom',
      biens: 'Eigendommen',
      baux: 'Huurcontracten',
      loyers: 'Huurprijzen',
      edl: 'Plaatsbeschrijving',
      indexation: 'Indexering',
      signalements: 'Meldingen',
      preavis: 'Opzeggingen',
      budget: 'Budget',
      perso: 'Persoonlijk',
      pro: 'Professioneel',
      patrimoine: 'Vermogen',
      transactions: 'Transacties',
      reconciliation: 'Afstemming',
      invest: 'Belegging',
      syndic: 'Syndicus',
      ag: 'Vergaderingen',
      notaire: 'Notaris',
      checklists: 'Checklists',
      budgetCharges: 'Huurlasten',
      agenda: 'Agenda',
      tasks: 'Taken',
      glossaire: 'Woordenlijst',
      onboarding: 'Configuratie',
    },
    portal: {
      espaceClient: 'Klantenruimte',
      espaceLocataire: 'Huurdersruimte',
      acceder: 'Naar het portaal',
    },
    groups: {
      principal: 'Hoofdmenu',
      crm: 'CRM',
      proprio: 'Huurbeheer',
      syndic: 'Syndicus',
      finance: 'Financieel',
      notaire: 'Notaris',
      outils: 'Tools',
      admin: 'Beheer',
    },
    sections: {
      crm: 'CRM Vastgoed',
      proprio: 'Beheer Eigendom',
      modules: 'Modules',
      syndic: 'Syndicus',
      notaire: 'Notaris Tools',
      administration: 'Beheer',
      compte: 'Mijn account',
    },
    sectionDescs: {
      crmDesc: 'Contacten, mandaten, pipeline',
      proprioDesc: 'Eigendommen, huur, indexatie',
      modulesDesc: 'Budget, investering',
      syndicDesc: 'Mede-eigendommen, fondsen',
      notaireDesc: 'Schattingen, checklists',
      adminDesc: 'Team, facturering, exports',
      compteDesc: 'Profiel en instellingen',
    },
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overzicht van uw activiteiten.',
    kpi: {
      activeMandats: 'Actieve mandaten',
      transactionsMonth: 'Transacties deze maand',
      visitsWeek: 'Bezoeken deze week',
      pendingOffers: 'Openstaande biedingen',
      pipelineValue: 'Pipeline waarde',
      commissionMonth: 'Commissie maand',
      visitsMonth: 'Bezoeken deze maand',
      transactionsClosed: 'Afgesloten transacties',
      pipelinePondere: 'Gewogen pipeline',
      commissionsYtd: 'Commissies YTD',
    },
    kpiSection: 'Kernindicatoren',
    pipelineApercu: 'Pipeline overzicht',
    pipelineFullView: 'Volledig overzicht',
    dossiers: 'dossiers',
    stages: {
      visite: 'Bezoek',
      offre: 'Bod',
      compromis: 'Compromis',
      acte: 'Akte',
    },
    trends: {
      thisMonth: 'Deze maand',
      vsPrev: '— vs vorige',
      pending: 'In afwachting',
      pondere: 'Gewogen',
      sinceJan: 'Sinds jan.',
    },
    subs: {
      noMandats: 'Geen mandaten geregistreerd',
      prevMonth: '0 vorige maand',
      response48h: 'Antwoord binnen 48u',
      actesSignes: 'Akten getekend deze maand',
      pipelineFormula: 'Prospect x10% · Bod x50% · Compromis x90%',
      objectif: 'Doel: — € · 0% bereikt',
    },
    panels: {
      alertes: 'Meldingen & prioriteiten',
      activite: 'Recente activiteit',
      aria: 'Aria — suggesties',
      voirTout: 'Alles bekijken',
      historique: 'Geschiedenis',
      details: 'Details',
      voir: 'Bekijken',
    },
    empty: {
      noAlerts: 'Geen actieve meldingen',
      alertsSub: 'Verlopen mandaten, blokkerende documenten en slapende dossiers',
      noActivity: 'Nog niets',
      activitySub: 'Toegevoegde bezoeken, ontvangen biedingen en ondertekende mandaten',
      importContacts: 'Contacten importeren',
      noSuggestions: 'Geen suggesties',
      ariaSub: 'Aria analyseert uw dossiers en stelt prioritaire acties voor',
      noData: 'Geen gegevens',
    },
    recentActivity: 'Recente activiteit',
    alerts: 'Meldingen',
    quickActions: 'Snelle acties',
    newMandat: '+ Mandaat',
    newContact: '+ Contact',
    noActivity: 'Geen recente activiteit',
    devRoleSwitcher: 'Rol simuleren',
    roles: {
      agent: { label: 'Makelaar' },
      agencyAdmin: {
        label: 'Kantoor Beheerder',
        title: 'Mijn kantoor',
        subtitle: 'Geconsolideerd overzicht van het kantoor',
        kpi: {
          caYtd: 'Omzet YTD',
          mandatsSigns: 'Getekende mandaten',
          tauxTransfo: 'Conversieratio',
          nps: 'Gemiddelde NPS',
          leads: 'Leads deze maand',
          pipelinePrev: 'Voorspelde pipeline',
        },
        subs: {
          commissions: 'Geinde commissies',
          newMandats: 'Nieuwe mandaten',
          leadsToMandats: 'Leads → getekende mandaten',
          postTransaction: 'Na transactie',
          leadsSources: 'Immoweb · etalage · doorverwijzing',
          caPrev30j: 'Voorspelde omzet 30 dagen',
        },
        perfAgent: 'Prestaties per makelaar',
        noAgent: 'Geen actieve makelaars',
        inviteSub: 'Nodig uw team uit om de prestaties te bekijken',
        inviteBtn: 'Makelaar uitnodigen',
        treso: 'Voorspelde schatkist 6 maanden',
        tresoSub: 'Vul de pipeline in om de projecties te zien',
        alertesManager: 'Manager meldingen',
        alertesSub: 'Slapende dossiers, onvolledig AML, inactieve makelaars 7d',
      },
      collaborator: {
        label: 'Medewerker',
        title: 'Mijn ruimte',
        subtitle: 'Stagiair · toegewezen',
        today: 'Vandaag',
        visitesJour: 'Bezoeken van de dag',
        tachesDues: 'Vervallen taken',
        relancesAria: 'Aria opvolgingen',
        tachesAssignees: 'Mijn toegewezen taken',
        noTaches: 'Geen toegewezen taken',
        tachesSub: 'Uw door de makelaar toegewezen taken verschijnen hier',
        pipelineRo: 'Pipeline (alleen lezen)',
        noDossiers: 'Geen lopende dossiers',
        pipelineSub: 'U kunt de dossiers raadplegen maar niet wijzigen',
      },
      client: { label: 'Klant' },
      locataire: { label: 'Huurder' },
      owner: {
        label: 'Eigenaar',
        title: 'Mijn panden',
        subtitle: 'Patrimia Proprio',
        kpi: {
          biensLocation: 'Panden verhuurd',
          loyersMois: 'Huur van de maand',
          signalements: 'Openstaande meldingen',
        },
        subs: {
          noBien: 'Geen panden geregistreerd',
          loyerDetail: '0 betaald · 0 in afwachting',
          reparations: 'Lopende reparaties',
        },
        trends: {
          moisCourant: 'Maart 2026',
        },
        panelBiens: 'Mijn panden',
        ajouter: 'Toevoegen',
        noBien: 'Geen panden geregistreerd',
        bienSub: 'Voeg uw eerste pand toe om het huurbeheer te starten',
        ajouterBien: 'Pand toevoegen',
        panelIndexation: 'Indexatie PropTax',
        simuler: 'Simuleren',
        noIndexation: 'Geen geplande indexatie',
        indexationSub: 'De indexatievervaldagen verschijnen hier',
      },
      syndic: {
        label: 'Syndicus',
        title: 'Syndicus — Beheer van mede-eigendommen',
        subtitle: 'Overzicht van uw mede-eigendommen, provisies en vergaderingen.',
        kpi: {
          copros: 'Beheerde mede-eigendommen',
          lots: 'Totale kavels',
          appels: 'Uitgestuurde provisies',
          impayes: 'Wanbetalingen',
          ag: 'Geplande AV',
          tresorerie: 'Globale schatkist',
        },
        subs: {
          copros: 'Aantal mede-eigendommen in beheer',
          lots: 'Alle types inbegrepen',
          appels: 'Lopend kwartaal',
          impayes: 'Totaal wanbetalingen > 30 dagen',
          ag: 'Komende algemene vergaderingen',
          tresorerie: 'Geconsolideerd saldo alle fondsen',
        },
        panelSinistres: 'Lopende schadegevallen',
        noSinistre: 'Geen schadegevallen gemeld',
        sinistreSub: 'Schadegevallen en dringende interventies verschijnen hier',
        panelAG: 'Volgende AV',
        planifierAG: 'Plannen',
        noAG: 'Geen AV gepland',
        agSub: 'Plan uw volgende algemene vergadering',
      },
      notaire: {
        label: 'Notaris',
        title: 'Notariskantoor — Vastgoedtools',
        subtitle: 'Schattingen, conformiteitschecklists en dossierbeheer.',
        kpi: {
          estimations: 'Lopende schattingen',
          checklists: 'Actieve checklists',
          dossiers: 'Dossiers deze maand',
        },
        subs: {
          estimations: 'Vastgoedschattingen in afwachting van validatie',
          checklists: 'Lopende conformiteitscontroles',
          dossiers: 'Akten en compromissen in voorbereiding',
        },
        panelEstimations: 'Recente schattingen',
        noEstimation: 'Geen lopende schattingen',
        estimationSub: 'Maak een schatting aan voor een vastgoed',
        nouvelleEstimation: 'Nieuwe schatting',
        panelChecklists: 'Conformiteitschecklists',
        noChecklist: 'Geen lopende checklists',
        checklistSub: 'Controleer de documentaire conformiteit van een dossier',
        nouvelleChecklist: 'Nieuwe checklist',
      },
      portal: {
        title: 'Portaalruimte',
        message: 'Toegang tot het portaal via de speciale link. Het klant- en huurderportaal beschikt over een eigen ruimte.',
        cta: 'Toegang tot het portaal',
      },
    },
  },
  contacts: {
    title: 'Contacten',
    subtitle: 'Beheer uw kopers, verkopers, huurders en prospects.',
    create: 'Nieuw contact',
    types: {
      buyer: 'Koper',
      seller: 'Verkoper',
      tenant: 'Huurder',
      landlord: 'Eigenaar',
      prospect: 'Prospect',
    },
    fields: {
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'E-mail',
      phone: 'Telefoon',
      type: 'Type',
      status: 'Status',
      budget: 'Budget',
      source: 'Bron',
      tags: 'Tags',
      notes: 'Notities',
    },
    empty: 'Geen contacten. Begin met het aanmaken van een contact.',
    exportCsv: 'CSV exporteren',
  },
  mandats: {
    title: 'Mandaten',
    subtitle: 'Verkoop- en verhuurmandaten.',
    create: 'Nieuw mandaat',
    status: {
      draft: 'Concept',
      active: 'Actief',
      'under-offer': 'Onder bod',
      compromis: 'Compromis',
      acte: 'Akte getekend',
      expired: 'Verlopen',
      withdrawn: 'Ingetrokken',
    },
    fields: {
      reference: 'Referentie',
      type: 'Type',
      price: 'Prijs',
      address: 'Adres',
      surface: 'Oppervlakte',
      rooms: 'Kamers',
      bedrooms: 'Slaapkamers',
      status: 'Status',
      agent: 'Agent',
      vendor: 'Verkoper',
    },
    empty: 'Geen mandaten. Maak uw eerste verkoopmandaat aan.',
  },
  pipeline: {
    title: 'Pipeline',
    subtitle: 'Volg uw lopende transacties.',
    stages: {
      'nouveau-contact': 'Nieuw contact',
      'visite-planifiee': 'Bezoek gepland',
      'offre': 'Bod',
      'negociation': 'Onderhandeling',
      'compromis': 'Compromis',
      'conditions': 'Voorwaarden',
      'acte': 'Akte',
      'abandonne': 'Gestopt',
    },
    changeReason: 'Reden van wijziging',
    empty: 'Geen lopende transacties.',
  },
  aria: {
    name: 'Aria',
    placeholder: 'Stel uw vraag aan Aria...',
    disclaimer: 'Deze berekening is indicatief en vormt geen officieel fiscaal advies.',
    thinking: 'Aria denkt na...',
    suggestions: 'Aria suggesties',
    noSuggestions: 'Geen suggesties op dit moment.',
  },
  portal: {
    welcome: 'Welkom op uw Patrimia-ruimte',
    contactAgent: 'Neem contact op met uw makelaar voor een nieuwe link.',
    dossier: 'Mijn dossier',
    timeline: 'Voortgang',
    documents: 'Documenten',
    messages: 'Berichten',
    sendMessage: 'Bericht versturen',
    noMessages: 'Geen berichten',
    noDocuments: 'Geen documenten beschikbaar',
    tabDossier: 'Dossier',
    tabOffres: 'Biedingen',
    tabEstimation: 'Schatting',
    tabConditions: 'Voorwaarden',
    tabPostVente: 'Na verkoop',
    tabBien: 'Catalogus',
    tabFaireOffre: 'Bod uitbrengen',
    tabSimulateur: 'Simulator',
    tabComparateur: 'Vergelijker',
    tabFeedback: 'Mijn beoordeling',
    kpiVisites: 'Bezoeken',
    kpiOffres: 'Biedingen',
    kpiEtape: 'Fase',
    stages: {
      draft: 'Concept', active: 'Actief', 'under-offer': 'Bod ontvangen',
      compromis: 'Compromis', acte: 'Akte getekend',
    } as Record<string, string>,
    montant: 'Bedrag',
    prixDemande: 'Vraagprijs',
    conditions: 'Voorwaarden',
    conditionsPlaceholder: 'Opschortende voorwaarden, termijnen...',
    messageAgent: 'Bericht aan de makelaar',
    messagePlaceholder: 'Een woord voor de makelaar...',
    envoyerOffre: 'Mijn bod versturen',
    envoyerContreOffre: 'Mijn tegenbod versturen',
    offreSent: 'Uw bod is succesvol verstuurd.',
    contreOffreSent: 'Uw tegenbod is succesvol verstuurd.',
    noOffres: 'Nog geen biedingen.',
    faireContreOffre: 'Tegenbod doen',
    faireOffreTitle: 'Online bod uitbrengen',
    feedbackTitle: 'Uw beoordeling na het bezoek',
    ratingLabel: 'Algemene score',
    positifs: 'Pluspunten',
    negatifs: 'Verbeterpunten',
    commentaire: 'Commentaar',
    commentairePlaceholder: 'Deel uw indruk...',
    wouldRecommend: 'Zou u dit pand aanbevelen?',
    envoyerFeedback: 'Beoordeling versturen',
    feedbackSent: 'Bedankt voor uw beoordeling!',
    tags: {
      luminosite: 'Lichtinval', agencement: 'Indeling', quartier: 'Buurt',
      calme: 'Rust', 'etat-general': 'Algemene staat', jardin: 'Tuin',
      terrasse: 'Terras', parking: 'Parking', transports: 'Vervoer',
      commerces: 'Winkels', bruit: 'Lawaai', humidite: 'Vocht',
      travaux: 'Werken', taille: 'Grootte', isolation: 'Isolatie', prix: 'Prijs',
    } as Record<string, string>,
    simApport: 'Eigen inbreng',
    simDuree: 'Looptijd',
    simAnnees: 'jaren',
    simTaux: 'Rente',
    simRegion: 'Gewest',
    simResultats: 'Simulatieresultaten',
    simMensualite: 'Maandlast',
    simEmprunt: 'Geleend bedrag',
    simFraisNotaire: 'Notariskosten',
    simDroits: 'Registratierechten',
    simInterets: 'Totale rente',
    simCoutGlobal: 'Totale kost',
    simDisclaimer: 'Indicatieve simulatie. Raadpleeg uw bank voor een persoonlijk aanbod.',
    noComparables: 'Geen vergelijkbare panden beschikbaar.',
    comparablesTitle: 'Vergelijkbare panden',
    sortPrix: 'Sorteer op prijs',
    sortSurface: 'Sorteer op oppervlakte',
    sortPrixM2: 'Sorteer op prijs/m2',
    compType: 'Type',
    compCommune: 'Gemeente',
    compSurface: 'Oppervlakte',
    compChambres: 'Slaapkamers',
    compPrix: 'Prijs',
    estType: 'Type',
    estSurface: 'Oppervlakte',
    estChambres: 'Slaapkamers',
    estRapport: 'Schattingsrapport',
    estDate: 'Berekendatum',
    estNone: 'Geen schatting beschikbaar.',
    photos: 'foto\'s',
    noPhotos: 'Geen foto',
    noBiens: 'Geen panden beschikbaar.',
    biensDisponibles: 'Beschikbare panden',
    condRemplie: 'Voldaan',
    condEnCours: 'Lopend',
    dateCompromis: 'Datum compromis',
    dateActe: 'Verwachte akte datum',
    parrainageTitle: 'Verwijzingsprogramma',
    parrainageDesc: 'Verwijs een kennis en geniet van exclusieve voordelen.',
    parrainageNom: 'Naam van de verwezen persoon',
    parrainageEmail: 'Email van de verwezen persoon',
    parrainerBtn: 'Verwijzen',
    parrainageSent: 'Verwijzing geregistreerd!',
    mesParrainages: 'Mijn verwijzingen',
    statusPending: 'In afwachting',
    statusConverted: 'Geconverteerd',
  },
  landing: {
    skipToContent: 'Ga naar hoofdinhoud',
    nav: {
      features: 'Functies',
      calculator: 'Rekenmachine',
      pricing: 'Tarieven',
      contact: 'Contact',
    },
    hero: {
      titlePre: 'De Belgische ',
      titleAccent: 'vastgoedmakelaar',
      titlePost: ' verdient beter dan een Excel-sheet',
      subtitle: 'Bespaar 2u per dag, verlies geen enkel mandaat meer. CRM, geïntegreerde fiscaliteit en AI — alles beheerd vanuit één platform om uw activiteit te sturen.',
      cta: 'Toegang aanvragen',
      login: 'Inloggen',
    },
    cta: {
      trial: 'Gratis proefperiode 14 dagen',
      demo: 'Demo bekijken',
    },
    painPoint: 'U jongleert tussen 4 tools, u vergeet follow-ups, u berekent registratierechten op een los blaadje. Wij hebben Patrimia gebouwd om daar een einde aan te maken.',
    features: {
      sectionTitle: 'Alles wat een Belgische makelaar nodig heeft',
      aria: {
        title: 'Aria, uw AI-assistent',
        description: 'Koper-matching, advertenties schrijven, prijsscoring, e-mailtriage — Aria automatiseert repetitieve taken zodat u zich kunt concentreren op uw klanten.',
        badgeNew: 'Nieuw',
      },
      proptax: {
        title: 'Fiscaliteit PropTax',
        description: '7 ingebouwde rekenmachines — registratierechten, onroerende voorheffing, huurindexering. Alle 3 de Belgische gewesten gedekt.',
        badgeBE: 'Exclusief BE',
      },
      crm: {
        title: 'Vastgoed CRM',
        description: 'Contacten, mandaten, verkooppipeline, bezoeken, biedingen — alles in een.',
      },
      portals: {
        title: 'Klantenportalen',
        description: 'Uw verkopers en kopers volgen hun dossier in realtime.',
      },
      livret: {
        title: 'Eigendomsbrochure PDF',
        description: 'Genereer professionele brochures met een klik.',
      },
      mailbox: {
        title: 'Mailbox Pro',
        description: 'Intelligente e-mailtriage door Aria — leads, dossiers, bezoeken.',
      },
    },
    social: {
      stats: {
        agents: { value: '200+', label: 'Gebruikende makelaars' },
        regions: { value: '3', label: 'Belgische gewesten' },
        tools: { value: '12', label: 'AI-tools' },
      },
      testimonial: {
        quote: 'Patrimia bespaart me 2u per dag op mijn follow-ups.',
        author: 'Sophie M., zelfstandig makelaar, Namen',
      },
    },
    wiifm: {
      ariaLabel: 'Wat Patrimia voor iedereen betekent',
      sectionTitle: 'Wat u er zelf aan heeft',
      sectionSubtitle: 'Patrimia vereenvoudigt het leven van alle betrokkenen bij een transactie — niet alleen dat van de makelaar.',
      agent: {
        label: 'Vastgoedmakelaar',
        intro: 'Concentreer u op uw klanten. Aria en PropTax doen de rest.',
        benefits: {
          time: { title: '2u per dag gewonnen', desc: 'Follow-ups, e-mailtriage, fiscale berekeningen — geautomatiseerd. U keert terug naar de onderhandelingen.' },
          aria: { title: 'Geïntegreerde AI (Aria)', desc: 'Koper-matching, advertenties schrijven, prijsscoring, e-mailtriage — in één tool.' },
          proptax: { title: 'Fiscaliteit PropTax', desc: '7 Belgische rekenmachines: registratierechten, onroerende voorheffing, huurindexering. Alle 3 gewesten.' },
          crm: { title: 'Gecentraliseerd CRM', desc: 'Contacten, mandaten, pipeline, bezoeken — geen spreadsheet meer, geen verspreide tools.' },
          livret: { title: 'Eigendomsbrochure PDF', desc: 'Professionele brochure gegenereerd in 1 klik vanuit uw mandaatfiche.' },
          pipeline: { title: 'Verkooppipeline', desc: 'Visueel Kanban: volg elk dossier van bod tot akte in realtime.' },
        },
      },
      bailleur: {
        label: 'Eigenaar / Verhuurder',
        intro: 'Uw vastgoed, uw huurders, uw inkomsten — gevolgd zonder uw makelaar te bellen.',
        benefits: {
          suivi: { title: 'Realtime opvolging', desc: 'Beveiligd portaal: raadpleeg de voortgang van uw dossier op elk moment, zonder afspraak.' },
          messages: { title: 'Directe communicatie', desc: 'Wissel berichten uit met uw makelaar via de geïntegreerde berichtenservice — volledige geschiedenis, geen verloren e-mail.' },
          documents: { title: 'Gedeelde documenten', desc: 'EPC, plannen, huurcontract, compromis — online beschikbaar via uw portaal.' },
          indexation: { title: 'Huurindexering berekend', desc: 'Uw makelaar berekent de huurindexering in enkele seconden via PropTax. U ontvangt het resultaat.' },
        },
      },
      locataire: {
        label: 'Huurder',
        intro: 'Geen onzekerheid meer. Uw dossier is zichtbaar, uw documenten zijn toegankelijk, uw huur is berekend.',
        benefits: {
          portail: { title: 'Beveiligd portaal', desc: 'Unieke link verzonden door uw kantoor. Raadpleeg de status van uw huurdossier zonder account aan te maken.' },
          messages: { title: 'Berichten met het kantoor', desc: 'Stel uw vragen rechtstreeks in het portaal. Geen telefoon zonder antwoord of verloren e-mail meer.' },
          documents: { title: 'Uw documenten online', desc: 'Huurcontract, plaatsbeschrijving, EPC-certificaat, reglement — alles staat er, op elk moment te downloaden.' },
          indexation: { title: 'Transparante huurindexering', desc: 'Uw kantoor berekent de indexering via Patrimia. Het resultaat en de details worden naar u doorgestuurd in het portaal.' },
          transparency: { title: 'Geen verrassingen', desc: 'U ziet waar uw dossier staat: in behandeling, goedgekeurd, ondertekend. Geen onzekerheid.' },
        },
        note: 'Huurderstoegang wordt geactiveerd door uw kantoor — geen registratie van uw kant nodig.',
      },
    },
    aria: {
      heroLabel: 'Hero sectie',
      painLabel: 'Waarom Patrimia',
      featuresLabel: 'Functies',
      wiifmLabel: 'Wat u er zelf aan heeft',
      socialLabel: 'Sociaal bewijs',
      calculatorLabel: 'Fiscale rekenmachine',
      pricingLabel: 'Tarieven',
    },
    calculator: {
      badge: 'Gratis — zonder registratie',
      title: 'Bereken uw registratierechten',
      subtitle: 'Simuleer in realtime de aankoopkosten voor de 3 Belgische gewesten. Onmiddellijk resultaat, 100% conform de wetgeving 2026.',
      ariaLabel: 'Rekenmachine voor registratierechten',
      labels: {
        purchasePrice: 'Aankoopprijs',
        region: 'Gewest',
        isOnlyHome: 'Enige eigen woning',
      },
      regions: {
        wallonie: 'Wallonië',
        flandre: 'Vlaanderen',
        bruxelles: 'Brussel',
      },
      results: {
        amount: 'Te betalen rechten',
        effectiveRate: 'Effectief tarief',
        abatement: 'Vrijstelling',
        taxableBase: 'Belastbare grondslag',
      },
      cta: 'Toegang tot alle 7 fiscale rekenmachines',
      disclaimer: 'Indicatieve berekening op basis van de geldende wetgeving. Raadpleeg uw notaris voor een officiële berekening.',
    },
    mockup: {
      title: 'Patrimia Dashboard',
      mandatsActifs: 'Actieve mandaten',
      pipeline: 'Pipeline',
      contacts: 'Contacten',
      visitesWeek: 'Bezoeken/week',
      visite: 'Bezoek',
      offre: 'Bod',
      nego: 'Onderhandeling',
      compromis: 'Compromis',
      acte: 'Akte',
    },
    footer: {
      tagline: 'All-in-one vastgoed CRM voor de Belgische markt',
      linksTitle: 'Product',
      links: {
        features: { label: 'Functies', href: '#features' },
        pricing: { label: 'Tarieven', href: '#pricing' },
        contact: { label: 'Contact', href: 'mailto:contact@patrimia.be' },
      },
      legalTitle: 'Juridisch',
      legal: {
        mentions: 'Juridische vermeldingen',
        privacy: 'Privacybeleid',
      },
      copyright: '© 2026 Patrimia — IT-Transform. Alle rechten voorbehouden.',
    },
  },
  mailbox: {
    title: 'Mailbox Pro',
    description: 'Intelligente e-mailtriage door Aria — leads, dossiers, bezoeken.',
    inbox: 'Inbox',
    compose: 'Opstellen',
    triage: 'AI Triage',
    settings: 'Instellingen',
    notConfigured: 'Mailbox niet geconfigureerd. Configureer uw IMAP-instellingen.',
    noEmails: 'Geen e-mails.',
    send: 'Versturen',
    reply: 'Beantwoorden',
    triageAction: 'Triageren met Aria',
    testConnection: 'Verbinding testen',
    connectionOk: 'Verbinding OK',
    save: 'Opslaan',
  },
  documents: {
    title: 'Documenten',
    description: 'Beheer documenten van uw mandaten en genereer eigendomsbrochures.',
    selectMandat: 'Selecteer een mandaat',
    selectPrompt: 'Selecteer een mandaat om de documenten te bekijken.',
    noMandats: 'Geen mandaten beschikbaar.',
    files: 'Documenten',
    noDocs: 'Geen documenten voor dit mandaat.',
    livret: 'Eigendomsbrochure',
    generateLivret: 'Brochure genereren',
    noLivrets: 'Geen brochures gegenereerd.',
    share: 'Delen',
    download: 'Downloaden',
  },
  admin: {
    title: 'Beheer',
    description: 'Beheer uw kantoor, team, commissies en prestaties.',
    team: 'Team',
    commissions: 'Commissies',
    performance: 'Prestaties',
    export: 'CSV exporteren',
    invite: 'Uitnodigen',
    mandats: 'Kantoor mandaten',
  },
  settings: {
    title: 'Instellingen',
    profile: 'Profiel',
    ariaConfig: 'Aria configuratie',
    billing: 'Facturatie',
    team: 'Team',
    integrations: 'Integraties',
  },
  billing: {
    currentPlan: 'Huidig plan',
    nextBilling: 'Volgende facturatie',
    trialEnds: 'Einde proefperiode',
    cancelScheduled: 'Annulering gepland aan het einde van de periode',
    paymentFailed: 'De laatste betaling is mislukt. Werk uw betaalmethode bij.',
    seats: 'Inbegrepen plaatsen',
    manageSubscription: 'Mijn abonnement beheren',
    addons: 'Aanvullende modules',
    addonActive: 'Actief',
    addonAdd: 'Toevoegen',
    free: 'Gratis',
    invoices: 'Factuurgeschiedenis',
    statuses: {
      active: 'Actief',
      trialing: 'Proefperiode',
      past_due: 'Betaling achterstallig',
      canceled: 'Geannuleerd',
      none: 'Geen',
    },
    pricingTitle: 'Eenvoudige en transparante tarieven',
    pricingSubtitle: 'Gratis proefperiode van 14 dagen op alle plannen. Zonder verplichtingen.',
    popular: 'Populair',
    contactUs: 'Contacteer ons',
    startTrial: 'Gratis proefperiode 14 dagen',
    plans: {
      solo: 'Solo',
      pro: 'Pro',
      agency: 'Kantoor',
      enterprise: 'Enterprise',
    },
    features: {
      crm: 'Volledig vastgoed CRM',
      aria_basic: 'Aria AI (20 verz./dag)',
      aria_full: 'Aria AI onbeperkt',
      proptax: 'Belastingcalculatoren',
      portal: 'Klantenportaal',
      mailbox: 'Intelligente mailbox',
      immoweb: 'Immoweb publicatie',
      livret: 'Eigendomsbrochure PDF',
      dashboard: 'Geconsolideerd dashboard',
      commissions: 'Commissiebeheer',
      seats_1: '1 agent inbegrepen',
      seats_3: '3 agenten inbegrepen',
      seats_10: '10 agenten inbegrepen',
      seats_unlimited: 'Onbeperkt agenten',
      all: 'Alle functionaliteiten',
      sso: 'SSO (Azure AD / Google)',
      api: 'API-toegang',
      account_manager: 'Toegewijde account manager',
    },
    addonsTitle: 'Aanvullende modules',
    addonNames: {
      proprio: 'Patrimia Proprio',
      syndic: 'Patrimia Syndic',
      invest: 'Patrimia Invest',
      budget: 'Patrimia Budget',
      notaire: 'Patrimia Notaire',
    },
  },
  // ── Proprio Phase 2 ──
  proprio: {
    biens: {
      title: 'Mijn panden',
      subtitle: 'Beheer uw panden en huurcontracten',
      addBail: 'Huurcontract toevoegen',
      empty: 'Geen panden geregistreerd. Voeg uw eerste huurcontract toe!',
    },
    bail: {
      tabInfo: 'Informatie',
      tabDocuments: 'Documenten',
      tabIndexation: 'Indexatie',
      tabQuittances: 'Kwitanties',
      tabEdl: 'Plaatsbeschrijving',
      tabSignalements: 'Meldingen',
      sectionBien: 'Het pand',
      sectionLocataire: 'Huurder',
      sectionFinances: 'Financiele voorwaarden',
      sectionBail: 'Contractdetails',
    },
    loyers: {
      title: 'Mijn huur',
      subtitle: 'Opvolging van betalingen en kwitanties',
      markPaid: 'Als betaald markeren',
      sendReceipt: 'Kwitantie versturen',
      downloadPdf: 'PDF downloaden',
    },
    edl: {
      title: 'Plaatsbeschrijving',
      entree: 'Intrede',
      sortie: 'Uittrede',
      addPiece: 'Kamer toevoegen',
      sign: 'Ondertekenen',
      generatePdf: 'PDF genereren',
    },
    signalements: {
      title: 'Meldingen',
      new: 'Nieuwe melding',
      analyzeAria: 'Analyseren met Aria',
    },
    indexation: {
      title: 'Indexatie',
      simulate: 'Simuleren',
      confirm: 'Indexatie bevestigen',
      history: 'Geschiedenis',
    },
    dashboard: {
      title: 'Mijn situatie',
      biensActifs: 'Actieve panden',
      loyersMensuels: 'Maandelijkse huur',
      impayes: 'Onbetaald',
      prochaineAction: 'Volgende actie',
    },
    nav: {
      mesBiens: 'Mijn panden',
      mesLoyers: 'Mijn huur',
      mesLocataires: 'Mijn huurders',
      edl: 'Plaatsbeschrijvingen',
      indexation: 'Indexatie',
      signalements: 'Meldingen',
      preavis: 'Opzegging',
      portail: 'Huurderportaal',
      aria: 'Aria Proprio',
      dashboard: 'Mijn situatie',
    },
  },
  budgetFinance: {
    nav: { title: 'Budget Financieel' },
    tabs: {
      synthese: 'Overzicht',
      perso: 'Persoonlijk',
      pro: 'Professioneel',
      patrimoine: 'Vermogen',
      transactions: 'Transacties',
      reconciliation: 'Afstemming',
      aria: 'Aria',
    },
    aria: {
      title: 'Aria — Budget Assistent',
      subtitle: 'Persoonlijk & professioneel financieel assistent',
      quickPrompts: 'Snelle acties',
      tools: 'Beschikbare tools',
      disclaimer: 'Deze prognoses zijn indicatief en vormen geen financieel advies.',
    },
    kpi: {
      revenusMensuels: 'Maandelijks inkomen',
      chargesMensuelles: 'Maandelijkse lasten',
      epargneMensuelle: 'Maandelijks sparen',
      patrimoineNet: 'Netto vermogen',
      investissements: 'Beleggingen',
      dettesRestantes: 'Resterende schulden',
      mrrPro: 'MRR Pro',
      arrPro: 'ARR Pro',
      tauxImpayes: 'Wanbetalingspercentage',
    },
    trends: { moisCourant: 'Deze maand', vsPrev: 'vs vorige', ytd: 'YTD' },
    fields: {
      nom: 'Naam', categorie: 'Categorie', montant: 'Bedrag',
      frequence: 'Frequentie', type: 'Type', statut: 'Status',
      date: 'Datum', description: 'Beschrijving',
    },
    actions: {
      ajouter: 'Toevoegen', modifier: 'Wijzigen', supprimer: 'Verwijderen',
      enregistrer: 'Opslaan', annuler: 'Annuleren', exporter: 'Exporteren',
    },
    categories: {
      logement: 'Huisvesting', transport: 'Vervoer', alimentation: 'Voeding',
      sante: 'Gezondheid', loisirs: 'Vrije tijd', education: 'Onderwijs',
      abonnements: 'Abonnementen', impots: 'Belastingen', assurances: 'Verzekeringen',
      epargne: 'Sparen', investissement: 'Belegging', divers: 'Diversen',
      salaire: 'Salaris', freelance: 'Freelance', locatif: 'Huurinkomsten',
      dividendes: 'Dividenden', allocations: 'Toelagen', autre: 'Overig',
    },
    frequences: {
      mensuel: 'Maandelijks', trimestriel: 'Driemaandelijks', semestriel: 'Halfjaarlijks',
      annuel: 'Jaarlijks', ponctuel: 'Eenmalig', hebdomadaire: 'Wekelijks',
    },
    synthese: {
      title: 'Budget — Overzicht',
      subtitle: 'Overzicht van uw persoonlijke en professionele financien',
      kpiSection: 'Kerncijfers',
      repartitionCharges: 'Verdeling lasten',
      repartitionChargeSub: 'Het donutdiagram verschijnt zodra er lasten zijn geregistreerd',
      analyseAria: 'Aria Analyse',
      analyseAriaSub: 'Aria zal uw financien analyseren en optimalisaties voorstellen',
    },
    perso: {
      title: 'Budget — Persoonlijk',
      subtitle: 'Persoonlijke lasten en inkomsten',
      chargesTitle: 'Persoonlijke lasten',
      revenusTitle: 'Inkomsten',
      emptyCharges: 'Geen persoonlijke lasten',
      emptyChargesSub: 'Voeg uw maandelijkse lasten toe om uw budget te volgen',
      emptyRevenus: 'Geen inkomsten geregistreerd',
      emptyRevenusSub: 'Voeg uw inkomstenbronnen toe',
    },
    pro: {
      title: 'Budget — Professioneel',
      subtitle: 'Professionele lasten en bedrijfsinkomsten',
      chargesTitle: 'Professionele lasten',
      revenusTitle: 'Professionele inkomsten',
      emptyCharges: 'Geen professionele lasten',
      emptyChargesSub: 'Voeg uw terugkerende professionele lasten toe',
      emptyRevenus: 'Geen professionele inkomsten',
      emptyRevenusSub: 'Voeg uw bronnen van professionele inkomsten toe',
    },
    patrimoine: {
      title: 'Budget — Vermogen',
      subtitle: 'Uitsplitsing van uw netto vermogen',
      actifs: 'Activa',
      engagements: 'Verplichtingen',
      emptyTitle: 'Geen vermogensgegevens',
      emptySub: 'Vermogenscategorieen verschijnen zodra accounts zijn geconfigureerd',
      categoriesLabels: {
        liquidites: 'Liquide middelen',
        epargne: 'Sparen',
        investissements: 'Beleggingen',
        pension: 'Pensioen',
        creances: 'Vorderingen',
        engagements: 'Verplichtingen',
      },
    },
    transactions: {
      title: 'Transacties',
      subtitle: 'Opvolging van financiele bewegingen',
      emptyTitle: 'Geen transacties',
      emptySub: 'Verbind uw bank via GoCardless of importeer een CODA/CSV-bestand om te beginnen',
      connectBtn: 'Bank verbinden',
      importBtn: 'Importeren',
      importCodaBtn: 'CODA-bestand',
      importCsvBtn: 'CSV-bestand',
      syncBtn: 'Synchroniseren',
      syncSuccess: '{imported} transacties geimporteerd, {duplicates} duplicaten genegeerd',
      allComptes: 'Alle rekeningen',
      allStatuts: 'Alle statussen',
      allMois: 'Alle maanden',
      compte: 'Rekening',
      sourceLabel: 'Bron',
      statuts: {
        importee: 'Geimporteerd',
        rapprochee: 'Afgestemd',
        validee: 'Gevalideerd',
        orpheline: 'Wees',
      },
      importCodaTitle: 'CODA-bestand importeren',
      importCsvTitle: 'CSV-bestand importeren',
      importCompte: 'Doelrekening',
      importSelectCompte: 'Selecteer een rekening',
      importFile: 'Bestand',
      importPaste: 'Of plak de inhoud',
      importCodaPlaceholder: 'Plak hier de inhoud van uw CODA-bestand...',
      importCsvPlaceholder: 'Plak hier de inhoud van uw CSV-bestand...',
      importDoBtn: 'Importeren',
      importClose: 'Sluiten',
      importSuccess: '{imported} transacties geimporteerd, {skipped} duplicaten genegeerd',
      importMoreErrors: 'bijkomende fouten',
      importError: 'Fout bij het importeren',
      gocardless: {
        connectTitle: 'Bankverbinding',
        connectSub: 'Selecteer uw bank om uw rekening te verbinden via PSD2',
        institutions: 'Beschikbare banken',
        syncing: 'Synchronisatie bezig...',
        syncDone: 'Synchronisatie voltooid',
      },
    },
    reconciliation: {
      title: 'Afstemming',
      subtitle: 'Geautomatiseerde bankafstemming met AI',
      runBtn: 'Afstemming starten',
      running: 'Analyse bezig...',
      statsAuto: 'Automatisch afgestemd',
      statsProposed: 'Te valideren',
      statsOrphaned: 'Wezen',
      proposedTitle: 'Afstemmingsvoorstellen',
      matchLabel: 'Voorgestelde match',
      confidenceLabel: 'Vertrouwen',
      internalTransfer: 'Interne overboeking',
      acceptBtn: 'Accepteren',
      rejectBtn: 'Afwijzen',
      emptyTitle: 'Geen voorstellen in afwachting',
      emptySub: 'Start een afstemming om uw niet-afgestemde transacties te analyseren',
      resultSuccess: 'Afstemming voltooid',
      resultDetail: '{auto} automatisch, {proposed} te valideren, {orphaned} wezen',
      highConfidence: 'Hoog vertrouwen',
      mediumConfidence: 'Gemiddeld vertrouwen',
      lowConfidence: 'Laag vertrouwen',
    },
  },
  // ── Calendar (F22) ──
  calendar: {
    title: 'Agenda',
    subtitle: 'Plan uw bezoeken, afspraken en deadlines',
    newEvent: 'Nieuw evenement',
    upcoming: 'Komende evenementen',
    noEvents: 'Geen komende evenementen',
    types: {
      visite: 'Bezoek',
      rdv: 'Afspraak',
      compromis: 'Compromis',
      acte: 'Akte',
      relance: 'Opvolging',
      ag: 'AV',
      autre: 'Overig',
    } as Record<string, string>,
    fields: {
      title: 'Titel',
      type: 'Type',
      start: 'Start',
      end: 'Einde',
      location: 'Locatie',
      notes: 'Notities',
    },
    status: {
      confirmed: 'Bevestigd',
      tentative: 'Voorlopig',
      cancelled: 'Geannuleerd',
    },
  },
  // ── Tasks Eisenhower (F17) ──
  tasks: {
    title: 'Taken',
    subtitle: 'Eisenhower matrix — prioriteer uw acties',
    newTask: 'Nieuwe taak',
    ariaSuggests: 'Aria stelt voor',
    emptyQuadrant: 'Geen taken',
    quadrants: {
      'urgent-important': 'Dringend + Belangrijk',
      'not-urgent-important': 'Belangrijk',
      'urgent-not-important': 'Dringend',
      'not-urgent-not-important': 'Delegeren / elimineren',
    } as Record<string, string>,
    fields: {
      title: 'Titel',
      description: 'Beschrijving',
      quadrant: 'Kwadrant',
      priority: 'Prioriteit',
      dueDate: 'Deadline',
      tags: 'Tags',
    },
    priority: {
      high: 'Hoog',
      medium: 'Gemiddeld',
      low: 'Laag',
    },
    status: {
      todo: 'Te doen',
      in_progress: 'Bezig',
      done: 'Klaar',
      cancelled: 'Geannuleerd',
    },
  },
  // ── Publication (F9) ──
  publication: {
    title: 'Publicaties',
    subtitle: 'Beheer uw advertenties op vastgoedportalen',
    publish: 'Publiceren',
    unpublish: 'Depubliceren',
    syncStats: 'Synchroniseren',
    portals: {
      immoweb: 'Immoweb',
      immovlan: 'Immovlan',
      zimmo: 'Zimmo',
      'logic-immo': 'Logic-Immo',
      facebook: 'Facebook',
    } as Record<string, string>,
    status: {
      draft: 'Concept',
      published: 'Gepubliceerd',
      paused: 'Gepauzeerd',
      expired: 'Verlopen',
      error: 'Fout',
    },
    stats: {
      views: 'Weergaven',
      contacts: 'Contacten',
      favorites: 'Favorieten',
    },
    lastSync: 'Laatste synchronisatie',
    noPublications: 'Geen publicaties',
    bulkPublish: 'Op meerdere portalen publiceren',
  },
  permissions: {
    insufficientPermissions: 'Onvoldoende rechten',
    noAccess: 'U heeft geen toegang tot deze bron',
    readOnly: 'Alleen-lezen toegang',
    supportReadOnly: 'De Support rol staat alleen lezen toe',
    supportAccessDisabled: 'Ondersteuning is niet geactiveerd voor deze tenant',
    supportBadge: 'Ondersteuning',
    platformAdmin: 'Platform Beheerder',
    requiresRole: 'Deze actie vereist de rol: {role}',
    contactOwnOnly: 'U kunt alleen uw eigen contacten zien',
    cannotCreateMandat: 'U bent niet gemachtigd om mandaten aan te maken',
    cannotModifyTransaction: 'U bent niet gemachtigd om transacties te wijzigen',
    impersonationActive: 'Impersonatie actief',
    impersonationBy: 'Ingelogd als {name} door {admin}',
    roles: {
      AGENT: 'Makelaar',
      AGENCY_ADMIN: 'Kantoor Beheerder',
      COLLABORATOR: 'Medewerker',
      CLIENT: 'Klant',
      SUPPORT: 'Ondersteuning',
      PLATFORM_ADMIN: 'Platform Beheerder',
    },
  },
  invest: {
    title: 'Investeringen',
    nav: { title: 'Investering navigatie' },
    tabs: {
      portefeuille: 'Portefeuille',
      simulateurLocatif: 'Huurrendement simulator',
      simulateurCredit: 'Krediet simulator',
      benchmark: 'Benchmark',
      fiscal: 'Fiscaal',
    },
    simulateurLocatif: {
      title: 'Huurrendement simulator',
      inputsTitle: 'Vastgoed parameters',
      prixAchat: 'Aankoopprijs',
      fraisNotaire: 'Notariskosten',
      travaux: 'Werken',
      loyerMensuel: 'Maandelijkse huur',
      chargesMensuelles: 'Maandelijkse kosten',
      taxeFonciere: 'Onroerende voorheffing',
      assurancePNO: 'PNO verzekering',
      vacanceLocative: 'Leegstand',
      gestionLocative: 'Beheerkosten',
      tauxImposition: 'Belastingtarief',
      prixTotal: 'Totale prijs',
      rendementBrut: 'Bruto rendement',
      rendementNet: 'Netto rendement',
      rendementNetNet: 'Netto-netto rendement',
      cashflowMensuel: 'Maandelijkse cashflow',
      tri10: 'IRR 10 jaar',
      tri15: 'IRR 15 jaar',
      tri20: 'IRR 20 jaar',
      chartTitle: 'Vermogen en cashflow evolutie over 20 jaar',
      chartPatrimoine: 'Vermogen',
      chartCashflow: 'Cumulatieve cashflow',
      chartXLabel: 'Jaren',
      save: 'Simulatie opslaan',
      euro: '\u20ac',
      euroMois: '\u20ac/maand',
      euroAn: '\u20ac/jaar',
    },
    simulateurCredit: {
      title: 'Hypotheeklening simulator',
      inputsTitle: 'Krediet parameters',
      montantEmprunte: 'Geleend bedrag',
      taux: 'Rentevoet',
      duree: 'Looptijd',
      typeCredit: 'Type krediet',
      fixe: 'Vast tarief',
      variable: 'Variabel tarief',
      apport: 'Eigen inbreng',
      fraisDossier: 'Dossierkosten',
      mensualiteLabel: 'Maandelijkse aflossing',
      coutTotal: 'Totale kosten krediet',
      coutInterets: 'Kosten intresten',
      chartTitle: 'Verdeling kapitaal / intresten per jaar',
      chartXLabel: 'Jaren',
      voirTableau: 'Aflossingstabel tonen',
      masquerTableau: 'Aflossingstabel verbergen',
      exportCSV: 'CSV exporteren',
      save: 'Opslaan',
      euro: '\u20ac',
      euroMois: '\u20ac/maand',
      annees: 'jaar',
      csvMois: 'Maand',
      csvMensualite: 'Aflossing',
      csvCapital: 'Kapitaal',
      csvInterets: 'Intresten',
      csvRestant: 'Restschuld',
    },
    benchmark: {
      title: 'Markt benchmark',
      chartTitle: 'Portefeuille prestaties vs indices (36 maanden)',
      tableTitle: 'Gedetailleerde vergelijking',
      portfolio: 'Mijn portefeuille',
      immoBelge: 'Belgisch vastgoed',
      rendementTotal: 'Totaal rendement',
      rendementAnnualise: 'Geannualiseerd rendement',
      volatilite: 'Volatiliteit',
      sharpe: 'Sharpe ratio',
      indice: 'Index',
    },
    fiscal: {
      title: 'Fiscale export',
      selectYear: 'Jaar selecteren',
      exportPDF: 'PDF exporteren',
      printTitle: 'Fiscaal overzicht — Patrimia Invest',
      printDate: 'Gegenereerd op',
      noData: 'Geen fiscale gegevens voor dit jaar. Voeg verworven projecten toe om het overzicht te genereren.',
      euro: '\u20ac',
      totalRevenus: 'Totale inkomsten',
      totalCharges: 'Totale kosten',
      baseImposable: 'Belastbare basis',
      estimationImpot: 'Geschatte belasting',
      sectionRevenus: 'Inkomsten',
      loyersBruts: 'Bruto huurinkomsten',
      revenusLocatifsNets: 'Netto huurinkomsten',
      revenusMobiliers: 'Roerende inkomsten',
      sectionCharges: 'Aftrekbare kosten',
      chargesDeductibles: 'Lopende kosten',
      taxeFonciere: 'Onroerende voorheffing',
      interetsEmprunt: 'Leningrente',
      amortissements: 'Afschrijvingen',
      travaux: 'Werken',
      assurances: 'Verzekeringen',
      fraisGestion: 'Beheerkosten',
      sectionBelgique: 'Belgische specificiteiten',
      rcIndexe: 'Geindexeerd kadastraal inkomen',
      precompteImmobilier: 'Onroerende voorheffing',
      precompteMobilier: 'Roerende voorheffing (30%)',
      additionelsRC: 'Gemeentelijke opcentiemen op KI',
      sectionPlusValues: 'Meerwaarden',
      courtTerme: 'Korte termijn meerwaarden (< 5 jaar)',
      longTerme: 'Lange termijn meerwaarden (> 5 jaar)',
    },
  },
  // ── Templates communicatie ──
  templates: {
    title: 'Communicatietemplates',
    subtitle: 'Beheer uw e-mail-, SMS- en briefmodellen voor vastgoed.',
    create: 'Nieuw template',
    seedDefaults: 'Templates laden',
    allCategories: 'Alle categorieen',
    allChannels: 'Alle kanalen',
    preview: 'Voorvertoning',
    useTemplate: 'Template gebruiken',
    empty: 'Geen templates',
    emptySub: 'Laad de standaardtemplates of maak er zelf een aan.',
    categories: {
      prospection: 'Prospectie',
      mandat: 'Mandaat',
      visite: 'Bezoek',
      offre: 'Bod',
      compromis: 'Compromis',
      acte: 'Akte',
      locatif: 'Huur',
      syndic: 'Syndicus',
      admin: 'Beheer',
    },
    channels: {
      email: 'E-mail',
      sms: 'SMS',
      courrier: 'Brief',
    },
  },
  // ── Integraties ──
  integrations: {
    title: 'Integraties',
    subtitle: 'Verbind uw externe tools en diensten om Patrimia te verrijken.',
    connect: 'Verbinden',
    disconnect: 'Verbreken',
    statusConnected: 'Verbonden',
    statusDisconnected: 'Niet verbonden',
    statusError: 'Fout',
    providers: {
      billtobox: 'BillToBox',
      izimi: 'IZIMI',
      mapbox: 'Mapbox',
      immoweb: 'Immoweb',
      notaire_be: 'Notaire.be',
    },
  },
  // ── Onboarding ──
  onboarding: {
    stepWelcome: 'Welkom',
    stepProfile: 'Kantoorprofiel',
    stepImport: 'Contacten importeren',
    stepMandat: 'Eerste mandaat',
    stepSummary: 'Overzicht',
    welcomeTitle: 'Welkom bij Patrimia',
    welcomeDesc: 'Laten we uw ruimte in een paar stappen instellen. U kunt alles later wijzigen in de instellingen.',
    profileTitle: 'Profiel van uw kantoor',
    agencyName: 'Naam van het kantoor',
    agencyPhone: 'Telefoon',
    agencyAddress: 'Adres',
    importTitle: 'Importeer uw contacten',
    importDesc: 'Importeer een CSV-bestand met uw bestaande contacten. Verwachte kolommen: naam, voornaam, e-mail, telefoon, type.',
    importChoose: 'Kies een CSV-bestand',
    importOptional: 'Optioneel — u kunt later importeren',
    mandatTitle: 'Uw eerste mandaat',
    mandatDesc: 'Voeg een eerste pand toe om de Patrimia-workflow te ontdekken.',
    mandatAddressLabel: 'Adres van het pand',
    mandatPriceLabel: 'Gevraagde prijs',
    mandatOptional: 'Optioneel — u kunt later mandaten aanmaken',
    summaryTitle: 'Alles klaar!',
    summaryDesc: 'Uw Patrimia-ruimte is geconfigureerd. U kunt beginnen te werken.',
    finish: 'Starten',
  },
  // ── Glossarium ──
  glossaire: {
    title: 'Vastgoedwoordenboek',
    subtitle: 'Termen en definities van de Belgische vastgoedmarkt',
    searchPlaceholder: 'Een term zoeken...',
    terms: 'termen',
  },
  // ── Snelle notities ──
  quickNotes: {
    title: 'Snelle notities',
    placeholder: 'Een notitie schrijven...',
    add: 'Toevoegen',
    empty: 'Geen notities',
    delete: 'Notitie verwijderen',
  },
  // ── NPS ──
  nps: {
    title: 'Uw mening telt',
    question: 'Zou u Patrimia aanbevelen aan een collega?',
    labelLow: 'Helemaal niet',
    labelHigh: 'Absoluut',
    commentPlaceholder: 'Een opmerking? (optioneel)',
    submit: 'Versturen',
    thanks: 'Bedankt voor uw feedback!',
  },
  // ── Sneltoetsen ──
  shortcuts: {
    title: 'Sneltoetsen',
    search: 'Globale zoekopdracht',
    newContact: 'Nieuw contact',
    newMandat: 'Nieuw mandaat',
    help: 'Sneltoetsen weergeven',
  },
  // ── Offline ──
  offline: {
    message: 'U bent offline',
  },
  // ── F33 — Vergelijking mandaten ──
  compare: {
    title: 'Eigendommen vergelijken',
    subtitle: 'Selecteer tot 3 mandaten om naast elkaar te vergelijken.',
    exportPdf: 'PDF exporteren',
    selectHint: 'Een eigendom selecteren',
    selectAtLeast2: 'Selecteer minstens 2 eigendommen',
    prix: 'Gevraagde prijs',
    surface: 'Oppervlakte',
    prixM2: 'Prijs / m²',
    pieces: 'Kamers',
    chambres: 'Slaapkamers',
    localisation: 'Locatie',
    revCadastral: 'Kadastraal inkomen',
    charges: 'Lasten',
    epc: 'EPC-score',
    ariaScore: 'Aria-score',
  },
  // ── F35 — Registratierechten ──
  droitsEnreg: {
    pageTitle: 'Registratierechten',
    pageSubtitle: 'Bereken de verwervingskosten voor een onroerend goed in Belgie.',
    title: 'Berekeningsmodule registratierechten',
    subtitle: 'Schatting op basis van gewest en kopersprofiel',
    prix: 'Aankoopprijs',
    region: 'Gewest',
    buyerType: 'Kopersprofiel',
    premierAchat: 'Eerste aankoop',
    investisseur: 'Investeerder',
    tvaLabel: 'Nieuwe woning met BTW',
    result: 'Geschatte registratierechten',
    disclaimer: 'Indicatieve schatting — raadpleeg een notaris voor een definitieve berekening.',
  },
  // ── F36 — Elektronische handtekening ──
  signature: {
    title: 'Elektronische handtekening',
    subtitle: 'Teken dit document door uw handtekening in het kader hieronder te plaatsen.',
    errLoad: 'Het te ondertekenen document kan niet worden geladen.',
    errGeneric: 'Er is een fout opgetreden.',
    errNetwork: 'Netwerkfout — controleer uw verbinding.',
    portal: 'Klantportaal',
    legalNotice: 'Door te ondertekenen gaat u akkoord met de voorwaarden en bevestigt u het document te hebben gelezen.',
    drawLabel: 'Teken hier uw handtekening',
    poweredBy: 'Beveiligde handtekening via Patrimia',
    alreadySigned: 'Dit document is al ondertekend.',
    placeholderText: 'Teken hier',
    clear: 'Wissen',
    submit: 'Ik onderteken',
  },
  // ── F37 — Presentatie eigendom ──
  presentation: {
    label: 'Presentatie',
    exitFullscreen: 'Volledig scherm verlaten',
    enterFullscreen: 'Volledig scherm',
    prevPhoto: 'Vorige foto',
    nextPhoto: 'Volgende foto',
    qrLabel: 'Scan om online te bekijken',
    keyboardHintPhotos: '← → fotos',
    keyboardHintExit: 'Esc verlaten',
  },
  aml: {
    tabTitle: 'AML Naleving',
    registreTitle: 'AML Register',
    procedureTitle: 'Interne AML procedure',
    trainingsTitle: 'AML Opleidingen',
    identification: 'Identificatie',
    riskAssessment: 'Risicobeoordeling',
    originOfFunds: 'Herkomst van fondsen',
    validation: 'Validatie',
    status: 'Status',
    statusIncomplete: 'Onvolledig',
    statusPendingReview: 'Wacht op validatie',
    statusPending_review: 'Wacht op validatie',
    statusApproved: 'Goedgekeurd',
    statusRejected: 'Afgewezen',
    statusCtifDeclared: 'CFI aangifte',
    statusCtif_declared: 'CFI aangifte',
    statusBlocked: 'Geblokkeerd',
    riskLevel: 'Risiconiveau',
    riskLow: 'Laag',
    riskMedium: 'Gemiddeld',
    riskHigh: 'Hoog',
    client: 'Klant',
    amount: 'Bedrag',
    date: 'Datum',
    actions: 'Acties',
    approveKyc: 'Goedkeuren',
    rejectKyc: 'Afwijzen',
    declareCtif: 'Aangifte bij CFI',
    createDossier: 'KYC dossier aanmaken',
    noDossier: 'Geen KYC dossier voor deze transactie',
    notIdentified: 'Niet geidentificeerd',
    missingItems: 'Ontbrekende elementen',
    riskTriggers: 'Risicofactoren',
    exportCsv: 'CSV exporteren',
    rejectReasonPrompt: 'Reden van afwijzing (min 3 tekens):',
    kycRequired: 'KYC dossier te voltooien voor {clientName}',
    kycBlocking: 'Compromis kan niet worden ondertekend zonder goedgekeurd KYC',
    eddRequired: 'Verhoogde waakzaamheid vereist (EDD)',
    procedureOverdue: 'AML procedure: herziening te laat',
    trainingOverdue: 'Jaarlijkse AML opleiding ontbreekt',
    ariaDisclaimer: 'Aria biedt hulp — de AML-verantwoordelijkheid blijft bij de erkende BIV-agent.',
    dashboardCompliant: 'Conforme dossiers',
    dashboardPending: 'In afwachting',
    dashboardOverdue: 'Onvolledig > 48u',
    procedureUpToDate: 'Procedure: actueel',
    procedureMissing: 'Procedure: afwezig',
    procedureOverdueShort: 'Procedure: herziening te laat',
    nextReview: 'Volgende herziening',
    viewRegistre: 'AML register bekijken',
  },
  notifications: {
    title: 'Meldingen',
    label: 'Meldingen',
    panelLabel: 'Meldingenpaneel',
    unread: 'ongelezen',
    markAllRead: 'Alles als gelezen markeren',
    empty: 'Geen meldingen',
  },
  userMenu: {
    myAccount: 'Mijn account',
    settings: 'Instellingen',
    logout: 'Uitloggen',
  },
  // ── P1-02 : SyndicPage i18n ──
  syndicPage: {
    title: 'Syndicus — Mede-eigendom',
    tabs: { copros: 'Mede-eigendommen', lots: 'Kavels', appels: 'Provisieoproepen', dashboard: 'Dashboard' },
    newCopro: 'Nieuwe mede-eigendom',
    fields: {
      nom: 'Naam van de mede-eigendom',
      adresse: 'Adres',
      codePostal: 'Postcode',
      commune: 'Gemeente',
      milliemes: 'Totaal duizendsten',
    },
    create: 'Aanmaken',
    emptyCopro: 'Geen mede-eigendom',
    emptyCoproSub: 'Gebruik de knop hierboven om er een aan te maken.',
    addLot: 'Kavel toevoegen',
    lotFields: {
      numero: 'Nummer (A01)',
      etage: 'Verdieping',
      quotites: 'Duizendsten',
      nomProprio: 'Naam eigenaar',
      emailOptional: 'E-mail (optioneel)',
    },
    add: 'Toevoegen',
    emptyLots: 'Geen kavels',
    emptyLotsSub: 'Gebruik de knop hierboven om kavels toe te voegen.',
    lotPrefix: 'Kavel',
    milliemesLabel: 'duizendsten',
    newAppel: 'Nieuwe provisieoproep',
    appelFields: {
      label: 'Omschrijving',
      trimestre: 'Kwartaal (2026-Q1)',
      montantTotal: 'Totaalbedrag',
    },
    createAppel: 'Oproep aanmaken',
    emptyAppels: 'Geen provisieoproepen',
    emptyAppelsSub: 'Gebruik de knop hierboven om er een aan te maken.',
    paye: 'Betaald',
    marquerPaye: 'Markeren als betaald',
    dashLabels: {
      lots: 'Kavels',
      totalAppels: 'Totaal oproepen',
      totalPaye: 'Totaal betaald',
      tauxRecouvrement: 'Inningspercentage',
    },
    confirmDelete: 'Weet u zeker dat u dit element wilt verwijderen?',
    accentColor: 'var(--color-primary)',
  },
  // ── P1-02 : NotairePage i18n ──
  notairePage: {
    title: 'Notaristools',
    tabs: { calculer: 'Kostencalculator', estimations: 'Mijn schattingen', checklists: 'Checklists' },
    calcTitle: 'Notariskosten in Belgie',
    fields: {
      prixVente: 'Verkoopprijs',
      region: 'Regio',
      habitationPropre: 'Eigen en enige woning',
      premierAchat: 'Eerste aankoop',
    },
    calculer: 'Berekenen',
    results: {
      droits: 'Registratierechten',
      honoraires: 'Ereloon notaris',
      divers: 'Diverse kosten',
      total: 'Totaal kosten',
      tauxEffectif: 'Effectief tarief',
    },
    sauvegarder: 'Opslaan',
    prixTotalEstime: 'Geschatte totaalprijs',
    emptyEstimations: 'Geen schattingen',
    emptyEstimationsSub: 'Gebruik de calculator om er een aan te maken.',
    checklistAchat: 'Checklist aankoop',
    checklistVente: 'Checklist verkoop',
    emptyChecklists: 'Geen checklists',
    emptyChecklistsSub: 'Gebruik de knoppen hierboven om er een aan te maken.',
    confirmDelete: 'Weet u zeker dat u dit element wilt verwijderen?',
  },
  // ── P1-02 : BudgetPage (charges locatives) i18n ──
  budgetChargePage: {
    title: 'Budget & Kosten',
    emptyBail: 'Geen actief huurcontract',
    emptyBailSub: 'Maak een huurcontract aan in Proprio om het budget te beheren.',
    tabs: { charges: 'Kosten', provisions: 'Voorzieningen', decomptes: 'Afrekeningen', resume: 'Overzicht' },
    addCharge: 'Kost toevoegen',
    fields: {
      label: 'Omschrijving',
      montant: 'Bedrag',
      mois: 'Maand',
      dateDebut: 'Startdatum',
      dateFin: 'Einddatum',
    },
    save: 'Opslaan',
    emptyCharges: 'Geen kosten geregistreerd',
    emptyChargesSub: 'Gebruik de knop hierboven om er een toe te voegen.',
    newProvision: 'Nieuwe voorziening',
    emptyProvisions: 'Geen voorzieningen',
    emptyProvisionsSub: 'Gebruik de knop hierboven om er een aan te maken.',
    payee: 'Betaald',
    marquerPayee: 'Markeren als betaald',
    genererDecompte: 'Afrekening genereren',
    generer: 'Genereren',
    emptyDecomptes: 'Geen afrekeningen',
    emptyDecomptesSub: 'Gebruik de knop hierboven om er een te genereren.',
    chargesReelles: 'Werkelijke kosten',
    provisionsLabel: 'Voorzieningen',
    solde: 'Saldo',
    resumeLabels: {
      chargesAnnuelles: 'Jaarlijkse kosten',
      provisionsMensuelles: 'Maandelijkse voorzieningen',
      provisionsPaid: 'Betaalde voorzieningen',
      balance: 'Balans',
    },
    repartitionCategorie: 'Verdeling per categorie',
    confirmDelete: 'Weet u zeker dat u dit element wilt verwijderen?',
  },
  // ── P1-03 : BudgetAriaPage i18n ──
  budgetAria: {
    headerSub: 'Assistent persoonlijke & professionele financien',
    placeholder: 'Stel uw vraag aan Aria Budget...',
    greeting: 'Hallo, ik ben {name}.',
    greetingSub: 'Stel me vragen over uw budget, investeringen of vermogen.',
    quickActions: 'Snelle acties',
    toolsTitle: 'Beschikbare tools',
    tools: {
      synthese: 'Maandoverzicht',
      charges: 'Kostenanalyse',
      dettes: 'Schulden & kredieten',
      portefeuille: 'Beleggingsportefeuille',
      patrimoineNet: 'Nettovermogen',
      projectionEpargne: 'Spaarprojectie',
      nonReconciliees: 'Niet-afgestemde transacties',
    },
    inputLabel: 'Bericht aan Aria Budget',
    sendLabel: 'Bericht verzenden',
    errConnection: 'Verbindingsfout met Aria.',
  },
  // ── P1-04 : SettingsPage i18n ──
  settingsPage: {
    onboarding: 'Onboarding',
    apiKeys: 'API-sleutels',
    currentPlan: 'Huidig abonnement',
    displayName: 'Weergavenaam',
    phone: 'Telefoon',
    agency: 'Kantoor',
    bio: 'Bio',
    language: 'Taal',
    langFr: 'Frans',
    langNl: 'Nederlands',
    langDe: 'Duits',
    aiNameLabel: 'Naam AI-assistent',
    aiNameHint: 'Pas de naam aan die in de AI-chat wordt weergegeven (bv: Aria, Richard, Alex...)',
    saving: 'Opslaan...',
    save: 'Opslaan',
    autoSuggestions: 'Automatische Aria-suggesties',
    triageEmail: 'Automatische e-mailtriage',
    confidenceThreshold: 'Betrouwbaarheidsdrempel (%)',
    maxDailyRequests: 'Max verzoeken / dag',
    apiKeyWarning: 'API-sleutels bieden programmatische toegang tot uw gegevens. Ze hebben dezelfde rechten als een AGENT op uw tenant. Deel nooit een sleutel — trek hem in als gecompromitteerd.',
    createNewKey: 'Nieuwe sleutel aanmaken',
    keyNamePlaceholder: 'Naam van de sleutel (bv: Richard, Zapier...)',
    create: 'Aanmaken',
    keyCreated: 'Sleutel aangemaakt — kopieer hem nu, hij wordt niet meer getoond',
    copy: 'Kopieren',
    copied: 'Gekopieerd!',
    keyCopied: 'Ik heb mijn sleutel gekopieerd',
    activeKeys: 'Actieve sleutels',
    loadingKeys: 'Laden...',
    noKeys: 'Geen API-sleutels.',
    createdOn: 'Aangemaakt op',
    lastUsed: 'Laatst gebruikt',
    expiresOn: 'Verloopt op',
    revokeConfirm: 'Deze sleutel intrekken? Deze actie is onomkeerbaar.',
    onboardingComplete: 'Onboarding voltooid! Uw account is succesvol geconfigureerd.',
    steps: {
      profile: 'Profiel voltooien',
      firstMandat: 'Eerste opdracht aanmaken',
      inviteTeam: 'Team uitnodigen',
      configAria: 'Aria AI configureren',
      configMailbox: 'Mailbox verbinden',
    },
    markDone: 'Markeren als gedaan',
  },
  // ── Voice Intelligence ──
  voice: {
    chat: 'Chat Aria',
    // FAB states
    fab: {
      idle: 'Spraaknotitie',
      recording: 'Opname bezig...',
      uploading: 'Audio verzenden...',
      processing: 'Verwerking bezig...',
      done: 'Voltooid',
      error: 'Fout',
      permissionDenied: 'Microfoontoegang geweigerd',
      maxDuration: 'Maximale duur bereikt',
    },
    // Recorder
    recorder: {
      timer: 'Duur',
      stop: 'Stoppen',
      hint: 'Druk om te stoppen · max 3 min',
      context: 'Gekoppeld eigendom',
    },
    // Processing steps
    processing: {
      transcribing: 'Transcriptie bezig...',
      extracting: 'Entiteiten extraheren...',
      executed: 'Acties uitgevoerd',
      steps: 'Verwerkingsstappen',
    },
    // Legacy keys (used by ProcessingSteps.tsx)
    stepTranscription: 'Transcriptie',
    stepExtraction: 'Extractie',
    stepExecution: 'Uitvoering',
    processingSteps: 'Verwerkingsstappen',
    // Results
    results: {
      actionsExecuted: 'Acties uitgevoerd',
      actionsRolledBack: 'Acties ongedaan gemaakt',
      noActions: 'Geen acties gedetecteerd',
    },
    // Undo
    undo: {
      title: 'Acties uitgevoerd',
      subtitle: 'U kunt binnen 30 seconden ongedaan maken',
      button: 'Ongedaan maken',
      expired: 'Annuleringstermijn verlopen',
      timer: 'Resterende tijd',
    },
    // Toast
    toast: {
      actionsCount: '{count} acties uitgevoerd',
      undoSuccess: 'Acties succesvol ongedaan gemaakt',
    },
    // History
    history: {
      title: 'Spraakgeschiedenis',
      empty: 'Geen spraaknotities — gebruik de microfoonknop op een eigendomsfiche',
      purged: 'Transcript verwijderd',
      status: {
        recording: 'Opname',
        transcribing: 'Transcriptie',
        extracting: 'Extractie',
        executed: 'Uitgevoerd',
        undone: 'Ongedaan gemaakt',
        error: 'Fout',
      },
    },
    // Action types
    actions: {
      create_rdv: 'Afspraak aanmaken',
      update_pipeline: 'Pipeline bijwerken',
      add_note: 'Notitie toevoegen',
      update_bien: 'Eigendom bijwerken',
    },
    // Errors
    errors: {
      micPermission: 'Geef alstublieft toegang tot de microfoon in uw browserinstellingen.',
      uploadFailed: 'Het verzenden van de audio is mislukt. Probeer opnieuw.',
      processingFailed: 'Verwerking mislukt. Probeer opnieuw.',
      undoFailed: 'Ongedaan maken mislukt.',
      undoExpired: 'De annuleringstermijn van 30 seconden is verlopen.',
      consentRequired: 'Toestemming is vereist om een spraaknotitie op te nemen.',
    },
    // Consent
    consent: {
      title: 'Toestemming opname',
      description: 'Ik bevestig dat ik alleen ben en dat er geen derden worden opgenomen.',
      checkbox: 'Ik bevestig',
    },
    // Page
    page: {
      title: 'Spraaknotities',
      subtitle: 'Geschiedenis van uw spraaknotities',
      filters: 'Filters',
      noResults: 'Geen spraaknotities gevonden',
      notesCount: 'notities',
      freeNote: 'Vrije dictatie',
      filterStatus: 'Filteren op status',
      filterBienId: 'Filteren op eigendom (ID)',
      allStatuses: 'Alle statussen',
      emptyTitle: 'Geen spraaknotities',
      emptyDescription: 'Gebruik de microfoonknop op een eigendomsfiche of vanaf de startpagina om uw notities in te spreken.',
    },
    // Inline
    inline: {
      sectionTitle: 'Spraaknotities',
      recordButton: 'Spraaknotitie',
      recordAriaLabel: 'Een spraaknotitie opnemen',
      noNotes: 'Geen spraaknotities voor dit eigendom',
      notePrefix: 'Notitie',
      actionsLabel: 'acties',
      close: 'Sluiten',
    },
    // Recording overlay
    recording: {
      label: 'Opname',
      startAriaLabel: 'Spraakopname starten',
      stopAriaLabel: 'Opname stoppen',
      tapToStop: 'Druk om te stoppen - max 3 min',
      associatedProperty: 'Gekoppeld eigendom',
      emptyRecording: 'Lege opname. Probeer opnieuw.',
    },
  },
  // ── Legal — Voice GDPR ──
  legal: {
    voice: {
      title: 'Spraaknotities — Gegevensbescherming',
      description: 'Spraaknotities worden automatisch getranscribeerd en de audio-inhoud wordt onmiddellijk na transcriptie verwijderd. De ruwe tekst wordt 72 uur bewaard en daarna gewist. Alleen de geextraheerde informatie (afspraken, status, notities) wordt bewaard in uw dossier.',
      audioRetention: 'Audio: onmiddellijk verwijderd na transcriptie',
      transcriptRetention: 'Ruwe transcriptie: 72 uur bewaard en daarna gewist',
      entitiesRetention: 'Geextraheerde gegevens: bewaard voor de duur van het mandaat + 5 jaar',
    },
  },
  readAloud: {
    title: 'Pre-bezoek briefing',
    generate: 'Briefing genereren',
    generating: 'Aria bereidt uw briefing voor…',
    sections: {
      property: 'Het Pand',
      buyer: 'De Koper',
      preparation: 'Voorbereiding',
      logistics: 'Praktische info',
    },
    cacheExpiry: 'Geldig tot {{time}}',
    notification: {
      title: 'Bezoek over {{minutes}} min',
      body: '{{address}} — Tik om de briefing te beluisteren',
    },
    error: {
      insufficientData: 'Onvoldoende gegevens. Controleer de eigendomsfiche en koper.',
    },
  },
}
